import React from 'react';
import ReactDOM from 'react-dom/client'; // Update import for React 18
import './index.css';
import { HashRouter } from 'react-router-dom';
import { AuthProvider } from './AuthContext';
import BRoutes from './BRoute';
import PRoute from './PRoute';
import { initDemoApi } from './demo/demoApi';
import { LanguageProvider } from './contexts/LanguageContext';
import { ModalProvider } from './contexts/ModalContext';
import { ThemeProvider } from './contexts/ThemeContext';
import SubmissionListener from './components/DemoSubmissionListener';
import ThemeSwitcher from './components/ThemeSwitcher';

initDemoApi();

const root = ReactDOM.createRoot(document.getElementById('root')); // Use createRoot
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <LanguageProvider>
        <ModalProvider>
          <AuthProvider>
            <HashRouter>
              <SubmissionListener />
              <PRoute />
              <BRoutes />
              <ThemeSwitcher />
            </HashRouter>
          </AuthProvider>
        </ModalProvider>
      </LanguageProvider>
    </ThemeProvider>
  </React.StrictMode>
);
